var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91406 0.921875C4.03125 0.664062 4.28906 0.5 4.57031 0.5H7.40625C7.6875 0.5 7.94531 0.664062 8.0625 0.921875L8.25 1.25H10.5C10.8984 1.25 11.25 1.60156 11.25 2C11.25 2.42188 10.8984 2.75 10.5 2.75H1.5C1.07812 2.75 0.75 2.42188 0.75 2C0.75 1.60156 1.07812 1.25 1.5 1.25H3.75L3.91406 0.921875ZM9.98438 11.4453C9.96094 12.0547 9.46875 12.5 8.85938 12.5H3.11719C2.50781 12.5 2.01562 12.0547 1.99219 11.4453L1.47656 3.5H10.5L9.98438 11.4453Z",
    fill: "#15161F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.6bd98e1efc1679ac7849b17ac8b24d2c.svg";
export { ForwardRef as ReactComponent };